/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Branding_Blocked_HintInputs */

const cs_templates_branding_blocked_hint = /** @type {(inputs: Templates_Branding_Blocked_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doplňte chybějící branding — teprve pak lze Použít / Generovat.`)
};

const en_templates_branding_blocked_hint = /** @type {(inputs: Templates_Branding_Blocked_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fix missing branding before Use / Generate.`)
};

/**
* | output |
* | --- |
* | "Fix missing branding before Use / Generate." |
*
* @param {Templates_Branding_Blocked_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_branding_blocked_hint = /** @type {((inputs?: Templates_Branding_Blocked_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Branding_Blocked_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_branding_blocked_hint(inputs)
	return cs_templates_branding_blocked_hint(inputs)
});